import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// CRM staff login uses the same admin authentication system.
// Redirect to the existing admin login page.
export default function CrmLogin() {
    const navigate = useNavigate();
    useEffect(() => {
        navigate('/admin/auth/login', { replace: true });
    }, [navigate]);
    return null;
}
